(function () {
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.product-details-block__toggle');
    if (!button) return;

    var panelId = button.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;

    var isOpen = button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      // Collapse
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // Force reflow
      panel.offsetHeight;
      panel.style.maxHeight = '0';
      panel.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');

      panel.addEventListener('transitionend', function handler() {
        panel.setAttribute('hidden', '');
        panel.removeEventListener('transitionend', handler);
      });
    } else {
      // Expand
      panel.removeAttribute('hidden');
      panel.style.maxHeight = '0';
      // Force reflow
      panel.offsetHeight;
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');

      panel.addEventListener('transitionend', function handler() {
        panel.style.maxHeight = '';
        panel.removeEventListener('transitionend', handler);
      });
    }
  });
})();
